import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

export type MessageCorporateSupportPayload = {
  message: string;
  pageUrl: string;
  regardingOpportunityId?: string;
};

export const messageCorporateSupport = (options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { defaultOnMutateSuccess } = useAPQuery();

  return useMutation({
    mutationFn: (payload: MessageCorporateSupportPayload) => {
      return fetchWithAuth("messageCorporateSupport", undefined, {
        requestOptions: {
          method: "post",
          body: JSON.stringify(payload),
        },
      });
    },
    onMutate: defaultOnMutateSuccess(options),
  });
};
